import { z } from 'zod';

export const TransferCoinsResult = z.object({
  success: z.boolean(),
  message: z.string(),
  amount: z.number(),
  transferId: z.string(),
});
export type TransferCoinsResult = z.infer<typeof TransferCoinsResult>;

export const ProgressTransferUpdate = z.object({
  seriesId: z.string(),
  beforeMaxUnlocked: z.number(),
  afterMaxUnlocked: z.number(),
});
export type ProgressTransferUpdate = z.infer<typeof ProgressTransferUpdate>;

export const ProgressIndicatorTransferUpdate = z.object({
  seriesId: z.string(),
  updatedData: z.record(z.string(), z.unknown()),
});
export type ProgressIndicatorTransferUpdate = z.infer<typeof ProgressIndicatorTransferUpdate>;

export const TransferProgressResult = z.object({
  success: z.boolean(),
  message: z.string(),
  readingProgressUpdates: z.array(ProgressTransferUpdate),
  listeningProgressUpdates: z.array(ProgressTransferUpdate),
  progressIndicatorUpdates: z.array(ProgressIndicatorTransferUpdate),
});
export type TransferProgressResult = z.infer<typeof TransferProgressResult>;

export const StripeSubscriptionTransferUpdate = z.object({
  stripeAccount: z.string(),
  result: z.string(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  sourceUserStripeCustomerId: z.string().optional(),
  targetUserStripeCustomerId: z.string().optional(),
  sourceUpdatedCustomerIdsClaim: z.record(z.string(), z.unknown()).optional(),
  targetUpdatedCustomerIdsClaim: z.record(z.string(), z.unknown()).optional(),
});
export type StripeSubscriptionTransferUpdate = z.infer<typeof StripeSubscriptionTransferUpdate>;

export const TransferStripeSubscriptionResult = z.object({
  success: z.boolean(),
  message: z.string(),
  updates: z.array(StripeSubscriptionTransferUpdate),
});
export type TransferStripeSubscriptionResult = z.infer<typeof TransferStripeSubscriptionResult>;

export const TransferResult = z.object({
  stripe: TransferStripeSubscriptionResult,
  points: TransferCoinsResult,
  progress: TransferProgressResult,
});
export type TransferResult = z.infer<typeof TransferResult>;

export const GTVProgressTransferResult = z.object({
  success: z.boolean(),
  message: z.string(),
  // note: using createSelectSchema(gtvSchema.seriesProgress) is not working as expected. Hence using z.any().
  // Since this is not a user facing data and we only store for internal use to display in retool dashboard, its fine for now.
  progressUpdates: z.any(),
});
export type GTVProgressTransferResult = z.infer<typeof GTVProgressTransferResult>;

export const GTVTransferResult = z.object({
  stripe: TransferStripeSubscriptionResult,
  coins: TransferCoinsResult,
  progress: GTVProgressTransferResult,
});
export type GTVTransferResult = z.infer<typeof GTVTransferResult>;

export const GTVGuestTransferResult = z.object({
  progressSeriesMerged: z.number().int().nonnegative(),
  unlocksCopied: z.number().int().nonnegative(),
});
export type GTVGuestTransferResult = z.infer<typeof GTVGuestTransferResult>;
